import { render, staticRenderFns } from "./addressSetting.vue?vue&type=template&id=2fab790c&scoped=true&"
import script from "./addressSetting.vue?vue&type=script&lang=js&"
export * from "./addressSetting.vue?vue&type=script&lang=js&"
import style0 from "./addressSetting.vue?vue&type=style&index=0&id=2fab790c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab790c",
  null
  
)

export default component.exports